var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaf = function SvgLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2 21q1-6 6-7t6-3m5-9q-2 4-8 4a7 7 0 0 0 0 14c1.92.061 3.817-.488 5.461-1.58 1.645-1.094 2.969-2.685 3.812-4.584a11.97 11.97 0 0 0 .947-6.124C20.994 5.612 20.224 3.63 19 2"
  })));
};
export default SvgLeaf;